export default function() {
  return [
    {
      title: "Dashboard",
      to: "/dashboard",
      htmlBefore: '<i class="material-icons">edit</i>',
      htmlAfter: ""
    },
    {
      title: "Users",
      htmlBefore: '<i class="material-icons">person</i>',
      to: "/user",
    },
    {
      title: "Blogs",
      htmlBefore: '<i class="material-icons">vertical_split</i>',
      to: "/blog-posts",
    }
//
,{
              to: '/Courses',
              title: 'Courses',
              htmlBefore: '<i class="material-icons">bookmark</i>',
                
            },
//
,{
              to: '/category',
              title: 'Classes',
              htmlBefore: '<i class="material-icons">bookmark</i>',
                
            },
//
,{
              to: '/SubCategory',
              title: 'Subjects',
              htmlBefore: '<i class="material-icons">bookmark</i>',
                
            },
            ,{
              to: '/Chapters',
              title: 'Chapters',
              htmlBefore: '<i class="material-icons">bookmark</i>',
                
            },
            ,{
              to: '/Exercises',
              title: 'Exercises',
              htmlBefore: '<i class="material-icons">bookmark</i>',
                
            },
//
,{
              to: '/Questions',
              title: 'Questions',
              htmlBefore: '<i class="material-icons">bookmark</i>',
                
            },
//
,{
              to: '/Videos',
              title: 'Videos',
              htmlBefore: '<i class="material-icons">bookmark</i>',
                
            },
            ,{
              to: '/Notestype',
              title: 'Notes Type',
              htmlBefore: '<i class="material-icons">bookmark</i>',
                
            }
//
,{
              to: '/Notes',
              title: 'Notes',
              htmlBefore: '<i class="material-icons">bookmark</i>',
                
            }
//

//REPLACE-COMPONENT-HERE
  ];
}
